export let DEVICE = 'desktop';

export function set_device(val) {
    DEVICE = val;
}
